const AISearchIdleView = () => {
  return <div className="flex min-h-[300px] flex-col gap-2"></div>
}

export default AISearchIdleView
